/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Physical_Reward_DescInputs */

const en_plan_physical_reward_desc = /** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is shipped monthly?`)
};

const es_plan_physical_reward_desc = /** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué se envía mensualmente?`)
};

const fr_plan_physical_reward_desc = /** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qui est expédié chaque mois ?`)
};

const de_plan_physical_reward_desc = /** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wird monatlich versendet?`)
};

const id_plan_physical_reward_desc = /** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang dikirimkan secara bulanan?`)
};

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const ja_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const zh_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const ar_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const it_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const ru_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const pt_plan_physical_reward_desc = en_plan_physical_reward_desc;

/** @type {(inputs: Plan_Physical_Reward_DescInputs) => LocalizedString} */
const ko_plan_physical_reward_desc = en_plan_physical_reward_desc;

/**
* | output |
* | --- |
* | "What is shipped monthly?" |
*
* @param {Plan_Physical_Reward_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_physical_reward_desc = /** @type {((inputs?: Plan_Physical_Reward_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Physical_Reward_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_physical_reward_desc(inputs)
	if (locale === "es") return es_plan_physical_reward_desc(inputs)
	if (locale === "fr") return fr_plan_physical_reward_desc(inputs)
	if (locale === "de") return de_plan_physical_reward_desc(inputs)
	if (locale === "ja") return ja_plan_physical_reward_desc(inputs)
	if (locale === "zh") return zh_plan_physical_reward_desc(inputs)
	if (locale === "ar") return ar_plan_physical_reward_desc(inputs)
	if (locale === "id") return id_plan_physical_reward_desc(inputs)
	if (locale === "it") return it_plan_physical_reward_desc(inputs)
	if (locale === "ru") return ru_plan_physical_reward_desc(inputs)
	if (locale === "pt") return pt_plan_physical_reward_desc(inputs)
	return ko_plan_physical_reward_desc(inputs)
});